import { useEffect, useState } from "react"
import axios from "../../../../api/axios"
import { isEmpty } from "../../../../Utilities/Utils"
import loadingIcon from '../../../../Images/loading.gif'
import Swal from "sweetalert2"
import { Link, Navigate, useNavigate } from "react-router-dom"
import {useAuth} from '../../../../ContextApp/AuthContext'

function Encodage(){
const {user}=useAuth()

const [eleves,setEleves]=useState([])
const [classes,setClasses]=useState([])
const [cotes,setCotes]=useState([])
const [cours,setCours]=useState([])
const [ponderation,setPonderation]=useState("")
const [periode,setPeriode]=useState("")
const navigate=useNavigate()
const [date_evaluation,setDate_evaluation]=useState("")

const [loading,setLoading]=useState(false)
const [classe,setClasse]=useState("")
const [cour,setCour]=useState("")

const recordcours=cours.filter((cr)=>cr.idclasse==classe && cr.idenseignant==user?.ecole[0]?.idenseignant)
const actual_cour=cours.filter((cr)=>cr.id==cour)
const recordseleves=eleves.filter((eleve)=>eleve.idclasse==classe)
const recordscotes=cotes.filter((cote)=>cote.idcour==cour && cote.periode==periode)
useEffect(()=>{
    HandleRequest()
    elevesrequest()
    coursRequest()
    handleallcotes()
   // dispatch(getsession(localStorage.getItem('email'),localStorage.getItem("id"),getCookie("gesco_inf")))
},[])
useEffect(()=>{
    setCour("")
},[classe])

const HandleRequest=async()=>{
    await axios.post('api/classes_getter',{idecole:user?.ecole[0]?.id}).then((res)=>{
        setClasses(res.data.items)
    }).catch((err)=>{
        
    })
}
const handlechange=(e)=>{
    if(isEmpty(ponderation)){
        Swal.fire({
            title:'Erreur',
            text:"Veuillez d'abord entrer la pondération de l'évaluation",
            icon:'error'
        })
        e.target.value=""
       
    }
    else{
        if(parseFloat(e.target.value)>parseFloat(ponderation)){
            
            Swal.fire({
                title:'Erreur de saisie',
            text:"Impossible d'avoir une note supérieur à la note de l'évaluation",
            icon:'error'
            })
            e.target.value=""
        }
        if(parseFloat(e.target.value)<0){
            Swal.fire({
            title:'Erreur de saisie',
            text:"Impossible d'avoir une note inférieur à 0",
            icon:'error'
            })
            e.target.value=""
        }
    }
}
const coursRequest=async()=>{
    await axios.post('api/getcours',{idecole:user?.ecole[0]?.id,annee_scolaire:user?.programme_scolaire?.annee_scolaire}).then((res)=>{
        setCours(res.data.items)
    }).catch((err)=>{
        
    })
}
const elevesrequest=async()=>{
    setLoading(true)
    await axios.post("api/allinscription",{idecole:user?.ecole[0]?.id,annee_scolaire:user?.programme_scolaire?.annee_scolaire}).then((res)=>{
        setEleves(res?.data?.items)
        setLoading(false)
    }).catch((err)=>{

    })
}
function emptyfield(){
    const nombre=document.getElementById("tableau").getElementsByTagName("input").length
    let my_table=""
    let my_count=0

    for(let i=0;i<nombre;i++){
     
        if(document.getElementById("tableau").getElementsByTagName("input")[i].value==""){
            const elev=document.getElementById("tableau").getElementsByTagName("span")[i].innerHTML
            my_table=my_table+elev+";\n"
        }
    }
    return (my_table)
}
function data_complete(){
    let my_data=[]
    const nombre=document.getElementById("tableau").getElementsByTagName("input").length
    for(let i=0;i<nombre;i++){
        const etat=!isEmpty(document.getElementById("tableau").getElementsByTagName("input")[i].value) ? true:false
    my_data=[
        ...my_data,
        {
            etat: etat,
            idinscription:parseInt(document.getElementById("tableau").getElementsByTagName("input")[i].name),
            point:parseFloat(document.getElementById("tableau").getElementsByTagName("input")[i].value),

        }
    ]
    }
return (my_data)
}

const handleclick=()=>{
    if(date_evaluation!=="" ){
    let message=""
    isEmpty(emptyfield()) ? message="Etes-vous sûr de vouloir enregistrer cette fiche de côte ?" : message="Vous n'avez pas renseigner des points pour certains élèves comme :\n"+emptyfield()+".\n Voulez-vous toujours enregistrer cette fiche des côtes ?"
    Swal.fire({
     title:"Demande de confirmation",
     text:message,
     icon:"question",
     showConfirmButton:true,
     confirmButtonText:"Confirmer",
     showCancelButton:true
    }).then((resultat)=>{
        if(resultat.isConfirmed){
            handlesave()
        }
    })
}
else{
    Swal.fire({
        title:"Erreur",
        text:"Veuillez d'abord renseigner la date de l'évaluation",
        icon:"error",
       }) 
}
}
const handleallcotes=async()=>{
    await axios.post('api/getallcotes',{idecole:user?.ecole[0]?.id,annee_scolaire:user?.programme_scolaire?.annee_scolaire}).then((res)=>{
        setCotes(res?.data?.items)
    }).catch((err)=>{

    })
}
const handlesave=async()=>{
    await axios.post('api/evaluation',{idecole:user?.ecole[0]?.id,annee_scolaire:user?.programme_scolaire?.annee_scolaire,idclasse:classe,idcour:cour,idenseignant:user?.ecole[0]?.idenseignant,ponderation:ponderation,date_evaluation:date_evaluation,periode:periode,data:data_complete()}).then((res)=>{
        if(res?.data?.status==200){
            Swal.fire({
                title:"Message d'enregistrement",
                text:res?.data?.message,
                icon:'success'
            })
            setClasse("")
            setCour("")
            setPonderation("")
            handleallcotes()
        }
    }).catch((err)=>{

    })
}
const Iteration = () => {
    return (loading) ? (
        <tr>
            <td colSpan="3" className="text-center py-5">
                <div className="spinner-border text-primary" role="status"></div>
                <div className="mt-2 text-muted small">Chargement des élèves...</div>
            </td>
        </tr>
    ) : (
        recordseleves.length > 0 &&
        recordseleves.map((elve, indexV) => (
            <tr key={elve.id} className="align-middle">
                <td className="ps-4 fw-bold text-muted" style={{ width: '50px' }}>
                    {indexV + 1}
                </td>
                <td>
                    <div className="fw-semibold text-dark text-uppercase small">
                       <span> {elve.nom_complet}</span>
                    </div>
                </td>
                <td className="pe-4" style={{ width: '120px' }}>
                    <div className="input-group input-group-sm">
                        <input 
                            type="number" 
                            name={elve.id} 
                            className="form-control form-control-lg border-primary-subtle text-center fw-bold rounded-3" 
                            placeholder="00"
                            onBlur={(e) => handlechange(e)} 
                        />
                    </div>
                </td>
            </tr>
        ))
    );
};
/*
const Allcote_eleve = () => {
    return (loading) ? (
        <div className="p-5 text-center">
            <div className="spinner-grow text-secondary spinner-grow-sm" role="status"></div>
        </div>
    ) : (
        <div className="table-responsive">
            <table className="table table-sm table-hover mb-0">
                <tbody>
                    {recordscotes.length > 0 ? (
                        recordscotes.map((cote, indexV) => (
                            <tr key={indexV} className="border-0">
                                <td className="ps-3 text-muted small border-0" style={{ width: '30px' }}>
                                    {indexV + 1}.
                                </td>
                                <td className="border-0">
                                    <span className="small fw-medium">{cote.nom_complet}</span>
                                </td>
                                <td className="text-end pe-3 border-0">
                                    <span className={`badge ${cote.somme >= (cote.somme_ponderation/2) ? 'bg-soft-success text-success' : 'bg-soft-danger text-danger'} rounded-pill fw-bold`}>
                                        {cote.somme} / {cote.somme_ponderation}
                                    </span>
                                </td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td className="text-center py-4 text-muted small italic">
                                Aucune cote enregistrée
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
};


const Allcote_eleve = () => {
    return (loading) ? (
        <div className="p-4 text-center">
            <div className="spinner-grow text-secondary spinner-grow-sm" role="status"></div>
        </div>
    ) : (
        <div className="table-responsive" style={{ overflowX: 'hidden' }}> 
           
            <table className="table table-sm table-hover mb-0 align-middle">
                <tbody>
                    {recordscotes.length > 0 ? (
                        recordscotes.map((cote, indexV) => (
                            <tr key={indexV} className="border-0 shadow-sm-hover">
                                
                                <td className="ps-2 text-muted border-0 fw-bold" style={{ width: '1%', fontSize: '0.75rem' }}>
                                    {indexV + 1}.
                                </td>
                                
                               
                                <td className="border-0 text-nowrap overflow-hidden text-truncate" style={{ maxWidth: '160px' }}>
                                    <span className="fw-semibold text-dark text-uppercase" style={{ fontSize: '0.8rem' }}>
                                        {cote.nom_complet}
                                    </span>
                                </td>
                                
                                
                                <td className="text-end pe-2 border-0 text-nowrap" style={{ width: '1%' }}>
                                    <span 
                                        className={`badge ${cote.somme >= (cote.somme_ponderation/2) ? 'bg-success-subtle text-success' : 'bg-danger-subtle text-danger'} rounded-pill fw-bold`}
                                        style={{ fontSize: '0.75rem', minWidth: '45px' }}
                                    >
                                        {cote.somme}/{cote.somme_ponderation}
                                    </span>
                                </td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td className="text-center py-3 text-muted small">Vide</td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
};

 */
const Allcote_eleve = () => {
    return (loading) ? (
        <div className="p-3 text-center">
            <div className="spinner-border spinner-border-sm text-secondary" role="status"></div>
        </div>
    ) : (
        <div className="list-group list-group-flush rounded-3">
            {recordscotes.length > 0 ? (
                recordscotes.map((cote, indexV) => (
                    <div 
                        key={indexV} 
                        className="list-group-item d-flex align-items-center justify-content-between py-2 px-2 border-bottom border-light"
                        style={{ fontSize: '0.85rem' }} // Police légèrement réduite pour mobile
                    >
                        {/* Bloc Gauche : Numéro + Nom */}
                        <div className="d-flex align-items-center overflow-hidden me-2">
                            <span className="fw-bold text-muted me-2" style={{ minWidth: '25px' }}>
                                {indexV + 1}.
                            </span>
                            <span className="fw-semibold text-dark text-nowrap text-truncate text-uppercase">
                                {cote.nom_complet}
                            </span>
                        </div>

                        {/* Bloc Droite : Note (Toujours aligné à droite) */}
                        <div className="text-nowrap ms-auto">
                            <span className={`badge ${cote.somme >= (cote.somme_ponderation/2) ? 'bg-success-subtle text-success' : 'bg-danger-subtle text-danger'} rounded-pill px-2 py-1 fw-bold border border-opacity-10`}>
                                {cote.somme}/{cote.somme_ponderation}
                            </span>
                        </div>
                    </div>
                ))
            ) : (
                <div className="p-4 text-center text-muted small italic">
                    Aucune donnée disponible
                </div>
            )}
        </div>
    );
};

    return(
       <>
        {/* Barre d'outils visible uniquement sur Mobile (d-lg-none) */}
        <div className="d-lg-none bg-white shadow-sm sticky-top p-2 mb-3 d-flex justify-content-between">
            <button className="btn btn-primary rounded-pill px-4" data-bs-toggle="offcanvas" data-bs-target="#offcanvasConfig">
                <i className="bi bi-sliders2-vertical me-2"></i> Config.
            </button>
            <button className="btn btn-dark rounded-pill px-4" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRecap">
                <i className="bi bi-list-check me-2"></i> Résumé
            </button>
        </div>
       
        <div className="container-fluid py-3 bg-light min-vh-100">
            <div className="row g-4">
                {/* Colonne Config (cachée sur mobile, col-lg-3 sur PC) */}
                <div className="col-lg-3">
                    {/* Panneau de Gauche : Configuration */}
                    <div className="offcanvas-lg offcanvas-start border-0 shadow" id="offcanvasConfig" tabIndex="-1">
                        <div className="offcanvas-header bg-primary text-white d-lg-none">
                            <h5 className="offcanvas-title fw-bold">Configuration</h5>
                            <button type="button" className="btn-close btn-close-white" data-bs-dismiss="offcanvas" data-bs-target="#offcanvasConfig"></button>
                        </div>
                        <div className="offcanvas-body p-0">
                            <div className="card border-0 shadow-sm rounded-4 w-100">
                                {/* ... Insérez ici votre contenu de sélection (Classe, Cours, Période) ... */}
                                <div className="card-header bg-primary text-white d-none d-lg-block py-3">
                                    <h5 className="mb-0 fw-bold">Configuration</h5>
                                </div>
                                <div className="card-body p-4">
                                    <div className="mb-3">
                                            <label className="form-label small fw-bold text-muted">Classe</label>
                                            <select className="form-select border-0 bg-light py-2" onChange={(e)=>setClasse(e.target.value)} value={classe}>
                                                <option value="">Choisir la classe...</option>
                                                {classes.map((clas)=> <option key={clas.id} value={clas.id}>{clas.nom}</option>)}
                                            </select>
                                        </div>

                                        <div className="mb-3">
                                            <label className="form-label small fw-bold text-muted">Cours</label>
                                            <select className="form-select border-0 bg-light py-2" onChange={(e)=>setCour(e.target.value)} value={cour}>
                                                <option value="">Choisir le cours...</option>
                                                {recordcours.map((cr)=> <option key={cr.id} value={cr.id}>{cr.cours}</option>)}
                                            </select>
                                        </div>

                                        <div className="mb-3">
                                            <label className="form-label small fw-bold text-muted">Période</label>
                                            <select className="form-select border-0 bg-light py-2" onChange={(e)=>setPeriode(e.target.value)} value={periode}>
                                                <option value="">Choisir la période...</option>
                                                <option value="P1">1ère Période</option>
                                                <option value="P2">2ème Période</option>
                                                <option value="Examen1">Examen S1</option>
                                                <option value="P3">3ème Période</option>
                                                <option value="P4">4ème Période</option>
                                                <option value="Examen2">Examen S2</option>
                                            </select>
                                        </div>

                                        <div className="row g-2">
                                            <div className="col-6">
                                                <label className="form-label small fw-bold text-muted">Pondération</label>
                                                <input type="number" className="form-control border-0 bg-light py-2" placeholder="Max" onChange={(e)=>setPonderation(e.target.value)} value={ponderation} />
                                            </div>
                                            <div className="col-6">
                                                <label className="form-label small fw-bold text-muted">Date</label>
                                                <input type="date" className="form-control border-0 bg-light py-2 small" onChange={(e)=>setDate_evaluation(e.target.value)} value={date_evaluation} />
                                            </div>
                                        </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Colonne Centrale (Saisie des points) - Toujours visible */}
                <div className="col-lg-5">
                    <div className="card border-0 shadow-sm rounded-4">
                        <div className="card-header bg-white py-3">
                            <h5 className="fw-bold mb-0">Saisie des points</h5>
                        </div>
                        <div className="card-body p-0">
                            <table className="table table-hover align-middle mb-0">
                                <tbody id="tableau">{Iteration()}</tbody>
                            </table>
                        </div>
                        <div className="p-3 border-top">
                            <button className="btn btn-primary w-100 py-3 fw-bold rounded-3" onClick={handleclick}>Enregistrer</button>
                        </div>
                    </div>
                </div>

                {/* Colonne Résumé (cachée sur mobile, col-lg-4 sur PC) */}
                <div className="col-lg-4">    
                    {/* Panneau de Droite : Résumé */}
                    <div className="offcanvas-lg offcanvas-end border-0 shadow" id="offcanvasRecap" tabIndex="-1">
                        <div className="offcanvas-header bg-dark text-white d-lg-none">
                            <h5 className="offcanvas-title fw-bold">Total fiche</h5>
                            <button type="button" className="btn-close btn-close-white" data-bs-dismiss="offcanvas" data-bs-target="#offcanvasRecap"></button>
                        </div>
                        <div className="offcanvas-body p-0">
                            <div className="card border-0 shadow-sm rounded-4 w-100">
                                <div className="card-header bg-dark text-white d-none d-lg-block py-3">
                                    <h5 className="mb-0 fw-bold text-center">Total fiche des cotes</h5>
                                </div>
                                <div className="card-body p-0">
                                    {Allcote_eleve()}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>




       </>
    )
}
export default Encodage